import { useApp } from '../store/AppContext';
import { AutopilotPanel } from './AutopilotPage';
import { PlaceholderPage } from './PlaceholderPage';
import { ScenariosPage } from './ScenariosPage';
import { WarmupPanel } from './WarmupPage';

function LaunchControl({ section }: { section: 'autopilot' | 'scenarios' | 'manual' }) {
  return (
    <section id="page-launch" className="lp">
      <h1 className="lp-h1">Запуск</h1>
      {section === 'autopilot' ? <AutopilotPanel /> : null}
      {section === 'scenarios' ? <div className="lp-scenarios"><h2>Сценарии</h2><ScenariosPage /></div> : null}
      {section === 'manual' ? <WarmupPanel /> : null}
    </section>
  );
}

export function LaunchPage() {
  const { ui } = useApp();
  if (ui.scope !== 'bing') {
    return <PlaceholderPage title="Запуск" />;
  }
  const section = ui.subpage === 'scenarios' || ui.subpage === 'manual' ? ui.subpage : 'autopilot';
  return <LaunchControl section={section} />;
}
